import { render, staticRenderFns } from "./PersonalName.vue?vue&type=template&id=133f1b9b&scoped=true&lang=html"
import script from "./PersonalName.vue?vue&type=script&lang=ts"
export * from "./PersonalName.vue?vue&type=script&lang=ts"
import style0 from "./PersonalName.vue?vue&type=style&index=0&id=133f1b9b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f1b9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133f1b9b')) {
      api.createRecord('133f1b9b', component.options)
    } else {
      api.reload('133f1b9b', component.options)
    }
    module.hot.accept("./PersonalName.vue?vue&type=template&id=133f1b9b&scoped=true&lang=html", function () {
      api.rerender('133f1b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PersonalName.vue"
export default component.exports